import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useI18n } from "@/context/i18n";
import { ShieldCheck, Phone, Mail } from "lucide-react";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="bg-[#0B2038] text-white mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Logo light className="h-14 sm:h-16" />
          <p className="text-white/60 max-w-sm leading-relaxed text-sm mt-5">{t("tagline")}</p>
          <div className="flex flex-col gap-2 mt-6 text-sm text-white/70">
            <span className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#009E9E]" /> +90 212 123 45 67</span>
            <span className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#009E9E]" /> hello@vayaholidays.com</span>
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#C9A227]" /> {t("secured")}</span>
          </div>
        </div>
        <div>
          <p className="label-caps mb-4 text-[#C9A227]">Türkiye</p>
          <ul className="space-y-2.5 text-white/70 text-sm">
            <li><Link to="/region/istanbul" data-testid="footer-region-istanbul" className="hover:text-white transition-colors">Istanbul</Link></li>
            <li><Link to="/region/antalya" data-testid="footer-region-antalya" className="hover:text-white transition-colors">Antalya</Link></li>
            <li><Link to="/region/bodrum" data-testid="footer-region-bodrum" className="hover:text-white transition-colors">Bodrum</Link></li>
            <li><Link to="/region/cappadocia" data-testid="footer-region-cappadocia" className="hover:text-white transition-colors">Cappadocia</Link></li>
            <li><Link to="/region/fethiye" data-testid="footer-region-fethiye" className="hover:text-white transition-colors">Fethiye</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-caps mb-4 text-[#C9A227]">Vaya Holidays</p>
          <ul className="space-y-2.5 text-white/70 text-sm"><li>About</li><li>Support</li><li>Terms</li><li>Privacy</li></ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-xs">© {new Date().getFullYear()} Vaya Holidays · Türkiye</div>
    </footer>
  );
};
